<script>
  import { urlParams, snippetsMap } from '../base/store'
  export let key, model
  let value
  const valuesMap = $snippetsMap[model]
// Handlers
  const handle = async e => {
    const newValue = e.target.value
    if (!!newValue) urlParams.setParam(key, [newValue])
      else urlParams.removeParam(key)
    await urlParams.applyFilters()
  }
  const set = () => {
    value = ($urlParams[key] || [])[0] || ""
  }
  $: $urlParams && set()
</script>


<select aria-placeholder="Выбрать" on:change={handle} bind:value={value}>
  <option value="" selected>--Все--</option>
  {#each (valuesMap || []) as [value, text]}
    <option value="{String(value)}">{text}</option>
  {/each}
</select>
